import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../style/gibraltar.css';

// Importing images for Latvia (1-11)
import latvia1 from '../images/latvia1.jpeg';
import latvia2 from '../images/latvia2.jpeg';
import latvia3 from '../images/latvia3.jpeg';
import latvia4 from '../images/latvia4.jpeg';
import latvia5 from '../images/latvia5.jpeg';
import latvia6 from '../images/latvia6.jpeg';
import latvia7 from '../images/latvia7.jpeg';
import latvia8 from '../images/latvia8.jpeg';
import latvia9 from '../images/latvia9.jpeg';
import latvia10 from '../images/latvia10.jpeg';
import latvia11 from '../images/latvia11.jpeg';

function Latvia() {
  const navigate = useNavigate();
  const [selectedImageIndex, setSelectedImageIndex] = useState(null);

  // Array of all imported images
  const photos = [
    latvia1, latvia2, latvia3, latvia4, latvia5, latvia6,
    latvia7, latvia8, latvia9, latvia10, latvia11
  ];

  // Function to handle image click
  const handleImageClick = (index) => {
    setSelectedImageIndex(index);
  };

  // Function to close the modal
  const closeModal = () => {
    setSelectedImageIndex(null);
  };

  // Function to navigate to the previous image
  const goToPrevious = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === 0 ? photos.length - 1 : prevIndex - 1
    );
  };

  // Function to navigate to the next image
  const goToNext = () => {
    setSelectedImageIndex((prevIndex) =>
      prevIndex === photos.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="gibraltar-page">
      <h1>🇱🇻 Latvia 2015 🇱🇻</h1>
      <button className="back-button" onClick={() => navigate(-1)}>
        &larr; 
      </button>

      <div className="photo-grid">
        {photos.map((photo, index) => (
          <div
            key={index}
            className="photo-item"
            onClick={() => handleImageClick(index)}
          >
            <img src={photo} alt={`Latvia ${index + 1}`} />
          </div>
        ))}
      </div>

      {/* Modal for displaying the larger image */}
      {selectedImageIndex !== null && (
        <div className="modal" onClick={closeModal}>
          <div className="modal-content">
            <button className="arrow left-arrow" onClick={(e) => { e.stopPropagation(); goToPrevious(); }}>
              &larr;
            </button>
            <img
              src={photos[selectedImageIndex]}
              alt="Selected"
              className="modal-image"
            />
            <button className="arrow right-arrow" onClick={(e) => { e.stopPropagation(); goToNext(); }}>
              &rarr;
            </button>
          </div>
        </div>
      )}
    </div>
  );
}

export default Latvia;